import { WorkspaceStoreImpl } from './workspaceImpl';

export function createWorkspaceStore() {
    return new WorkspaceStoreImpl({
        initialValue: {},
    });
}
